var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComparisonTypeFacilityFacility(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H5C3.34315 10 2 11.3431 2 13V27C2 28.6569 3.34315 30 5 30H17C18.6569 30 20 28.6569 20 27V13C20 11.3431 18.6569 10 17 10Z",
    fill: "#8080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10H35C33.3431 10 32 11.3431 32 13V27C32 28.6569 33.3431 30 35 30H47C48.6569 30 50 28.6569 50 27V13C50 11.3431 48.6569 10 47 10Z",
    fill: "#8080FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H7C6.44772 14 6 14.4477 6 15V17C6 17.5523 6.44772 18 7 18H9C9.55228 18 10 17.5523 10 17V15C10 14.4477 9.55228 14 9 14Z",
    fill: "#FF6833"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14H14C13.4477 14 13 14.4477 13 15V17C13 17.5523 13.4477 18 14 18H16C16.5523 18 17 17.5523 17 17V15C17 14.4477 16.5523 14 16 14Z",
    fill: "#FF6833"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39 14H37C36.4477 14 36 14.4477 36 15V17C36 17.5523 36.4477 18 37 18H39C39.5523 18 40 17.5523 40 17V15C40 14.4477 39.5523 14 39 14Z",
    fill: "#FF6833"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46 14H44C43.4477 14 43 14.4477 43 15V17C43 17.5523 43.4477 18 44 18H46C46.5523 18 47 17.5523 47 17V15C47 14.4477 46.5523 14 46 14Z",
    fill: "#FF6833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonTypeFacilityFacility);
export default __webpack_public_path__ + "static/media/comparison-type-facility-facility.bb39e7a6db84ded0c8c697fb07d9ee5d.svg";
export { ForwardRef as ReactComponent };